import React from "react";
import Label from "./Label";
import { parseSourceValue } from "./Utils";

interface SourceValueProps {
  value: React.ReactNode;
  sourceLabel?: string;
}

const SourceValue: React.FC<SourceValueProps> = ({ value, sourceLabel }) => {
  const parsed = parseSourceValue(value);
  const displayValue = sourceLabel ? value : parsed.value;
  const labelValue = sourceLabel || parsed.sourceLabel;

  if (
    displayValue === null ||
    displayValue === undefined ||
    displayValue === ""
  ) {
    return labelValue ? <Label value={labelValue} /> : null;
  }

  return (
    <>
      {displayValue}
      {labelValue && <Label value={labelValue} />}
    </>
  );
};

export default SourceValue;
